import { type ReactNode } from "react";
import { PhoneIcon } from "@icons";
import styles from "./MobileTabBar.module.css";

export interface MobileTabItem {
  key: string;
  label: string;
  icon: ReactNode;
}

/**
 * Floating pill tab bar with a raised center call FAB (Aria iOS v2 design).
 * Two tabs each side of the FAB; the FAB opens the app-wide dialer sheet.
 */
export function MobileTabBar({
  items,
  active,
  onChange,
  onCall,
}: {
  items: MobileTabItem[];
  active: string;
  onChange: (key: string) => void;
  onCall: () => void;
}) {
  const left = items.slice(0, 2);
  const right = items.slice(2, 4);
  const tab = (item: MobileTabItem) => (
    <button
      key={item.key}
      className={[styles.tab, item.key === active ? styles.active : ""].join(" ")}
      aria-current={item.key === active ? "page" : undefined}
      onClick={() => onChange(item.key)}
    >
      <span className={styles.icon}>{item.icon}</span>
      <span className={styles.label}>{item.label}</span>
    </button>
  );
  return (
    <nav className={styles.bar} aria-label="Main">
      {left.map(tab)}
      <div className={styles.fabSlot}>
        <button className={styles.fab} onClick={onCall} aria-label="Open dialer">
          <PhoneIcon width={26} height={26} />
        </button>
      </div>
      {right.map(tab)}
    </nav>
  );
}
